import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { ArrowLeft, BookOpen } from "lucide-react";
import NotFound from "./NotFound";

export default function Guide() {
  const { slug } = useParams();
  const [guide, setGuide] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/guides/${slug}?_=${Date.now()}`)
      .then((r) => setGuide(r.data))
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <div className="pt-8 max-w-3xl mx-auto px-4">Načítání…</div>;
  if (notFound) return <NotFound/>;

  return (
    <article className="pt-8 pb-20" data-testid="guide-page">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-zinc-500 hover:text-blue-600 mb-6"><ArrowLeft className="w-4 h-4"/>Zpět</Link>
        <div className="flex items-center gap-2 mb-3">
          <div className="w-9 h-9 rounded-xl bg-blue-50 flex items-center justify-center"><BookOpen className="w-5 h-5 text-blue-600"/></div>
          <div className="text-xs uppercase tracking-widest text-blue-600 font-semibold">Návod</div>
        </div>
        <h1 className="font-display text-4xl font-bold tracking-tight mb-6" data-testid="guide-title">{guide.title}</h1>
        <div
          className="prose prose-zinc max-w-none whitespace-pre-wrap text-zinc-700 leading-relaxed"
          data-testid="guide-content"
          dangerouslySetInnerHTML={{ __html: renderGuide(guide.content || "") }}
        />
      </div>
    </article>
  );
}

// Minimal renderer: supports HTML pass-through and converts plain-text URLs + line breaks
function renderGuide(content) {
  // If looks like HTML, render as-is
  if (/<\/?(p|div|h\d|ul|ol|li|a|strong|em|br|img|table)\b/i.test(content)) return content;
  // Plain text → escape, then linkify URLs, then keep newlines
  const esc = content.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  return esc
    .replace(/(https?:\/\/[^\s]+)/g, '<a href="$1" target="_blank" rel="noopener" class="text-blue-600 underline">$1</a>')
    .replace(/\n/g, "<br/>");
}
